import { Box, Typography } from '@mui/material'
import { TPatientInformationProps } from './PatientInformation.types'
import { usePatientInformationLogic } from './PatientInformation.logic'
import styles from './PatientInformation.styles.module.scss'

const PatientInformation: React.FC<TPatientInformationProps> = (props) => {
  const logic = usePatientInformationLogic(props)

  return (
    <Box className={styles.patient} data-testid="patient-procedure-info">
      {logic.isNurse && (
        <>
          <Typography fontSize="1rem" fontWeight="500">
            {logic.patientDisplayName}
          </Typography>
          <Typography>DOB: {logic.dateOfBirth}</Typography>
          <Typography>MRN: {logic.medicalRecordNumber}</Typography>
          <br />
        </>
      )}
      {logic.showSurgeryType && (
        <Typography>Surgery: {logic.surgeryDescription}</Typography>
      )}
      <Typography>Surgeon: {logic.surgeonName}</Typography>
    </Box>
  )
}

export default PatientInformation
